import React, { useMemo, useState } from "react";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import { deviceInventory } from "./deviceInventoryData";
import styles from "./complianceReportDetail.module.scss";

const HealthBar = ({ value }) => (
  <div className={styles.healthBar}>
    <span
      className={styles.healthFill}
      style={{ width: `${value}%` }}
      aria-label={`Health ${value}%`}
    />
  </div>
);

const DeviceInventoryTable = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const pagedRows = useMemo(
    () =>
      deviceInventory.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      ),
    [page, rowsPerPage]
  );

  const handleChangePage = (_, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div className={styles.inventoryCard}>
      <div className={styles.sectionHeader}>
        <div className={styles.sectionTitleRow}>
          <Inventory2OutlinedIcon className={styles.sectionIcon} />
          <span className={styles.sectionTitle}>
            Device Inventory • Immutable Fingerprints
          </span>
        </div>
      </div>

      <TableContainer className={styles.inventoryTableContainer}>
        <Table size="medium">
          <TableHead>
            <TableRow className={styles.inventoryHeadRow}>
              <TableCell className={styles.inventoryHeadCell}>Device</TableCell>
              <TableCell className={styles.inventoryHeadCell}>
                Purdue Level
              </TableCell>
              <TableCell className={styles.inventoryHeadCell}>
                SHA-256 Fingerprint
              </TableCell>
              <TableCell className={styles.inventoryHeadCell} align="center">
                Health
              </TableCell>
              <TableCell className={styles.inventoryHeadCell} align="center">
                SL
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pagedRows.map((row) => (
              <TableRow key={row.device} className={styles.inventoryRow}>
                <TableCell>
                  <div className={styles.deviceCell}>
                    <div className={styles.deviceName}>{row.device}</div>
                    <div className={styles.deviceMeta}>{row.model}</div>
                  </div>
                </TableCell>
                <TableCell>
                  <span className={styles.purduePill}>{row.purdue}</span>
                </TableCell>
                <TableCell className={styles.hashCell}>
                  <a
                    className={styles.hashLink}
                    href={row.hashUrl}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {row.hashDisplay}
                  </a>
                </TableCell>
                <TableCell className={styles.healthCell} align="center">
                  <HealthBar value={row.health} />
                  <span className={styles.healthValue}>{row.health}%</span>
                </TableCell>
                <TableCell align="center">
                  <span className={styles.slPill}>{row.sl}</span>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        count={deviceInventory.length}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[5, 10, 25]}
        className={styles.inventoryPagination}
      />
    </div>
  );
};

export default DeviceInventoryTable;
